import { createStyles } from '@/styles';

export default createStyles(() => ({
  classes: {
    root: 'flex items-center justify-center overflow-hidden absolute inset-0',
  },
  styles: {
    root: {},
  },
}));
